import { Button, Heading, Section, Text } from '@react-email/components';

import EmailLayout from './EmailLayout/EmailLayout';
import Message from './common/Message';
import Regards from './common/Regards';

//Staff member or provider
const NewPatientAccount = ({
    patientName,
    patientEmail,
    businessName,
    buisnessEmail, //required phone number here
    dob,
    gender,
    phoneNumber,
    appointmentId
}) => {

    return (
        <EmailLayout>
            <Section>
                <Message style={{ color: '#555', textAlign: 'left' }}>Dear {patientName},</Message>
                <Heading style={{ textAlign: 'left' }}>An appointment has been created against your mail by the business {businessName}. Kindly ignore this email if you didn't book an appointment.</Heading>
                <Text
                    style={{
                        textAlign: 'start',
                        color: '#555',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        lineHeight: 'normal',
                    }}
                >
                    To activate your account, there’s just one final step.
                </Text>
                <Text
                    style={{
                        textAlign: 'start',
                        color: '#555',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: 'normal',
                    }}
                >
                    Please create a password by clicking the link below to complete your registration:
                </Text>
            </Section>

            {/* Confirm Button */}
            <Section style={{ textAlign: 'center', marginTop: '20px' }}>
                <Button
                    href={`${process.env.REACT_APP_PATIENT_PORTAL_URL}/auth/signup?firstName=${encodeURIComponent(patientName)}&email=${encodeURIComponent(patientEmail)}&dob=${encodeURIComponent(dob)}&phoneNumber=${encodeURIComponent(phoneNumber)}&gender=${encodeURIComponent(gender)}&businessName=${encodeURIComponent(businessName)}&appointmentId=${encodeURIComponent(appointmentId)}`}
                    // href={`${process.env.REACT_APP_PATIENT_URL}/auth/signup?firstName=${encodeURIComponent(patientName)}&email=${encodeURIComponent(patientEmail)}&dob=${encodeURIComponent(dob)}&phoneNumber=${encodeURIComponent(phoneNumber)}&gender=${encodeURIComponent(gender)}&businessName=${encodeURIComponent(businessName)}&appointmentId=${encodeURIComponent(appointmentId)}`}
                    // href="https://your-confirmation-link.com"
                    style={{
                        padding: '10px 30px',
                        backgroundColor: '#FF5F39',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '28px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: 500,
                        fontFamily: 'Poppins, sans-serif',
                    }}
                >
                    Create Password to Finish Setup
                </Button>
            </Section>
            <Section>
                <Text
                    style={{
                        textAlign: 'start',
                        color: '#555',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: 'normal',
                    }}>
                    Once complete, your profile will be live, and patients will be able to book appointments with you through BeSeen. Should you need assistance at any point, don’t hesitate to reach out to us.
                </Text>
                <Text>
                    If you have any questions or need assistance, feel free to contact us at <a href={`mailto:${buisnessEmail}`}>{buisnessEmail}</a>.
                </Text>
            </Section>
            <Section>
                <Regards />
            </Section>
        </EmailLayout>
    );
};

export default NewPatientAccount;
